/**
 * What counts as a phone number on the quote and enquiry forms.
 *
 * The old rule was a strict mobile/landline pattern, and it turned away real
 * numbers: 1300 and 1800 lines (which is what a commercial caller gives),
 * the 13 range, a mobile written "+61 (0) 412 ...", a local eight-digit
 * landline with no area code, and anything separated with dots. Paul dials
 * the number, so the only thing worth refusing is something that cannot be
 * one. Eight digits is the shortest real local number and twenty covers an
 * international number dialled with the 0011 prefix.
 */

const MIN_DIGITS = 8
const MAX_DIGITS = 20

// "13 11 14" and the rest of the 13 range are six digits, the one real
// format shorter than a local landline.
const AU_THIRTEEN = /^13\d{4}$/

export const PHONE_MESSAGE = 'Please enter a valid phone number.'

export function looksLikePhone(value: string): boolean {
  const digits = value.replace(/\D/g, '')
  if (AU_THIRTEEN.test(digits)) return true
  return digits.length >= MIN_DIGITS && digits.length <= MAX_DIGITS
}

/** Digits, keeping a leading +, so a pasted "(03) 9754 1234" stores dialable. */
export function normalisePhone(value: string): string {
  const trimmed = value.trim()
  const plus = trimmed.startsWith('+') ? '+' : ''
  return plus + trimmed.replace(/\D/g, '')
}
